import styled from 'styled-components';
import { rem } from 'polished';
import media from '../../../styles/media';
import { CheckoutPreOrderStyled } from '../CheckoutPreOrderStyled';

export const CheckoutPreOrderStyledDS = styled(CheckoutPreOrderStyled)`
    .submitButton {
        button {
            width: 100%;
            height: ${rem(50)};
            padding: 0 ${rem(5)};

            ${media.sm`
                padding: 0 60px;
                height: 42px;
            `}
        }

        .loading {
            left: 3%;
        }
    }

    .subTitle {
        margin-bottom: ${rem(30)};
    }
`;
